import React from 'react'
import {Typography, Grid} from '@mui/material';
import colors from '../../../colors'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useSelector } from 'react-redux';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';

const SingleInvoice = (props) => 
{ 
    const globalDataSliceState = useSelector(selectGlobalDataState)
    
    return(
        <Grid container>
            <Grid container item md={12} xs={12} >
                <ListItemButton disabled={globalDataSliceState.isLoading ? true : false} disableRipple={props.isMultiSelect ? true : false} sx={props.isMultiSelect ? {width:'100%', borderRadius:'20px', ":hover":{background:'none'}} : {width:'100%', borderRadius:'20px'}} onClick={props.onClick}>
                    <ListItemIcon style={{paddingRight:'5%'}}>
                        {props.utilityName && props.utilityName.includes("UK") ?  <img width={'50px'} src={props.utilityInfo.image}/> : <img width={'50px'} src={props?.utilityInfo?.Images?.filter(image => image.color === 1 && image.size === 1)[0]?.imagePath} /> }
                    </ListItemIcon>
                    <ListItemText disableTypography={true} primary={<Typography color={colors.darkBlue} fontSize={'1.3rem'} fontFamily={'GerberaBold'}>{props.contractData[Object.keys(props.contractData)[0]]}</Typography>} secondary={Object.entries(props.contractData).slice(1, Object.entries(props.contractData).length).map(([key, value], index) => {
                        return <div style={{color:colors.gray, fontFamily:'GerberaLight'}} key={index}>{key}: {value}</div>
                    })} />                 
                </ListItemButton>
            </Grid>
        </Grid>
    )
}
export default SingleInvoice